import { useState } from "react";
import { Clock, Sparkles, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatRemaining, useSampleWindow } from "@/hooks/useSampleWindow";

/**
 * Tiny chip rendered in the top nav while the 30-min sample is active.
 * Click expands a popover explaining the free-then-upgrade model.
 */
export default function SampleCountdownChip() {
  const { remainingMs, expired, ready } = useSampleWindow();
  const [open, setOpen] = useState(false);
  if (!ready || expired) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-tour="sample-chip"
          className="hidden md:inline-flex items-center gap-1.5 rounded-full border border-primary/40 bg-primary/10 px-2.5 py-1 text-[11px] font-mono text-primary hover:bg-primary/20 transition-colors"
          aria-label="Sample time remaining"
        >
          <Clock className="h-3 w-3" />
          Sample · {formatRemaining(remainingMs)}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 text-sm">
        <div className="flex items-start gap-2">
          <Sparkles className="h-4 w-4 text-primary mt-0.5 shrink-0" />
          <div className="space-y-2">
            <p className="font-semibold">Your 30-minute sample</p>
            <p className="text-xs text-muted-foreground">
              Try every tool with no nudges. After it ends, you can keep going on
              the free plan or upgrade for more credits and faster models.
            </p>
            <p className="text-[11px] font-mono text-muted-foreground">
              {formatRemaining(remainingMs)} left
            </p>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="ml-auto text-muted-foreground hover:text-foreground"
            aria-label="Close"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}